<template>
    <div
        class="w-ful grid grid-flow-row gap-3 pb-2 pr-2 pt-2"
        :class="{
            'pl-2': indentationLevel === 0,
            'pl-[18px] text-sm': indentationLevel === 1,
            [`grid-cols-${gridCols}`]: true,
        }"
    >
        <slot></slot>
    </div>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{ indentationLevel?: number; gridCols?: number }>(), {
    indentationLevel: 0,
    gridCols: 5,
});
</script>
